/**
 * CheckoutCancel -- Stripe cancel_url lands here when the user backs out.
 */
import * as React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";

export default function CheckoutCancel() {
  return (
    <div className="mx-auto max-w-xl px-4 py-12 md:py-20">
      <Card elevated>
        <CardBody className="text-center py-10">
          <h1 className="text-2xl font-black mb-3">Checkout canceled</h1>
          <p className="text-ink-muted mb-6">
            No worries — nothing was charged. The listing is still there when you're ready.
          </p>
          <Link to="/">
            <Button variant="primary" size="lg" fullWidth>Back to marketplace</Button>
          </Link>
        </CardBody>
      </Card>
    </div>
  );
}
